import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@progress/kendo-react-common';
import { UserApi } from '../../../../redux/api/UserApi';
import { SvgIcon } from "@progress/kendo-react-common";
import * as svg from '@progress/kendo-svg-icons';
import { useGetTenantQuery } from '../../../../redux/api/BaseApi';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { isMobile } from 'react-device-detect';
import { Button } from '@progress/kendo-react-buttons';

const LegacyBanner: React.FC<ITicketProps> = (props) => {
    const { data: tenant } = useGetTenantQuery();
    const { data: profile } = UserApi.useGetUserProfileQuery();

    if (isMobile) return null;

    return (
        <div className='auto-status-banner mt-1 flex justify-content-between align-items-center' >
            <div className='flex align-items-center'><SvgIcon icon={svg.questionCircleIcon} style={{ marginRight: '8px' }} />
                Something not working or missing functionality?&nbsp;<u><Link className='nav-link' to={`/deeplink/?url=/calls/callhistory.aspx%3Fcall_id=${props.ID}%26from=newdetails`} rel="noopener">Go to the legacy details page.</Link></u>
            </div>
            <div><Link to={`/deeplink?url=/Contacts/ContactInfo.aspx%3FOrigin=Details%26Action=NavSettings%26Contact_Id=${profile.Id}`}><Button fillMode='flat' svgIcon={svg.gearIcon} title='Go to your display settings'></Button></Link> </div>
        </div >
    );
};

export default LegacyBanner;